declare global {
  interface Window {
    __APP_ENV__: string
  }
}

const env: string =
  typeof window !== 'undefined'
    ? window.__APP_ENV__
    : process.env.RAZZLE_NODE_ENV || process.env.NODE_ENV || 'development'

export default env
